import { useQueryClient } from '@tanstack/react-query';
import { useGetApiAdminCompanyByCompanyTreeSettingsId, } from '../../generated/sitComponents';
export function useGetCompanyById({ companyTreeSettingsId, }) {
    const queryClient = useQueryClient();
    return useGetApiAdminCompanyByCompanyTreeSettingsId({
        pathParams: {
            id: `${companyTreeSettingsId}`,
        },
    }, {
        // @ts-expect-error react-query v5 + OpenAPI does not support `initialData` yet: https://github.com/fabien0102/openapi-codegen/issues/184
        initialData: () => {
            return queryClient
                .getQueryData(['admin', 'companies'])
                ?.find((company) => company.id === companyTreeSettingsId);
        },
    });
}
//# sourceMappingURL=use-get-admin-company.js.map